import { laceParts0, laceParts1, laceParts2, laceParts3, laceParts4, laceParts5, laceParts6 } from './parts/laceParts'

export const lacingWeb1 = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(244, 194) // 左＿上
  ctx.quadraticCurveTo(273, 285, 314, 361) // 左＿下
  ctx.quadraticCurveTo(322, 355, 342, 307) // 右＿下
  ctx.quadraticCurveTo(313, 241, 290, 140) // 右＿上
  ctx.quadraticCurveTo(277, 120, 255, 134) // 中央＿上
  ctx.quadraticCurveTo(234, 154, 244, 194) // 左＿上
  ctx.fill()
  // ctx.stroke()
  ctx.closePath()
  // ヘリ革ここから
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(314, 361) // 左下＿外
  ctx.quadraticCurveTo(273, 285, 244, 194) // 左上＿外
  ctx.quadraticCurveTo(234, 154, 255, 134) // 中央上＿外
  ctx.quadraticCurveTo(276, 120, 290, 140) // 右上＿外
  ctx.quadraticCurveTo(310, 228, 342, 308) // 右下＿外
  ctx.quadraticCurveTo(336, 316, 336, 316) // 右下＿内
  ctx.quadraticCurveTo(302, 232, 282, 145) // 右上＿内
  ctx.quadraticCurveTo(272, 134, 261, 141) // 中央上＿内
  ctx.quadraticCurveTo(247, 155, 250, 177) // 左上＿内
  ctx.quadraticCurveTo(268, 253, 316, 347) // 左下＿内
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ヘリ革ここまで

  // stitchここから
  ctx.lineWidth = 1.1
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(316, 345) // 左下
  ctx.quadraticCurveTo(280, 280, 251, 178) // 左上
  ctx.quadraticCurveTo(249, 155, 262, 143) // 中央上
  ctx.quadraticCurveTo(271, 137, 280, 146) // 右上
  ctx.quadraticCurveTo(299, 226, 334, 315) // 右下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.lineWidth = 0.8
  ctx.closePath()
  // stitchここまで

  // laceここから
  baseLaceOfWetTopLeft(ctx, laceColor)
  baseLaceOfWetTopRight(ctx, laceColor)
  laceOfWebTopCenter(ctx, laceColor)
  laceParts0(ctx, laceColor, -12, -40) // ウェブ縦左上
  laceParts0(ctx, laceColor, -5, -17) // ウェブ縦左上
  laceParts0(ctx, laceColor, 2, 5) // ウェブ縦左上
  laceParts2(ctx, laceColor, 10, 23)
  laceParts2(ctx, laceColor, 18, 40)
  laceParts2(ctx, laceColor, 29, 60)
  laceParts2(ctx, laceColor, 37, 80)
  laceParts1(ctx, laceColor, 45, 75) // 上4
  laceParts1(ctx, laceColor, 32, 50) // 上3
  laceParts1(ctx, laceColor, 20, 30) // 上2
  laceParts1(ctx, laceColor, -2, -5) // 上1
  laceParts1(ctx, laceColor, -21, -30) // 上0
  laceParts3(ctx, laceColor, 25, 73) // 上5
  laceParts3(ctx, laceColor, 17, 49) // 上4
  laceParts3(ctx, laceColor, 8, 22) // 上3
  laceParts3(ctx, laceColor, -3, -8) // 上2
  laceParts3(ctx, laceColor, -10, -36) // 上1
  laceParts3(ctx, laceColor, -14, -55) // 上1
  laceParts4(ctx, laceColor, 29, 80) // 上5
  laceParts4(ctx, laceColor, 21, 57) // 上4
  laceParts4(ctx, laceColor, 11, 28) // 上3
  laceParts4(ctx, laceColor, 0, 0) // 上2
  laceParts4(ctx, laceColor, -8, -27) // 上1
  laceParts5(ctx, laceColor, -9, -60) // 上0
  laceParts5(ctx, laceColor, -8, -30) // 上1
  laceParts5(ctx, laceColor, 0, 0) // 上2
  laceParts5(ctx, laceColor, 11, 27) // 上3
  laceParts5(ctx, laceColor, 21, 55) // 上4
  laceParts5(ctx, laceColor, 29, 83) // 上5
  laceParts4(ctx, laceColor, -10, -52) // 上0
  laceParts4(ctx, laceColor, -2, -77) // 上0
  // laceParts6(ctx, laceColor, 0, 0) // 上2
  ctx.fillStyle = webColor
  // ウェブ先端_左
  LaceOfAroundWetTop1(ctx, laceColor, 31, -65)
  LaceOfAroundWetTop1(ctx, laceColor, 25, -58)
  LaceOfAroundWetTop1(ctx, laceColor, 20, -51)
  LaceOfAroundWetTop1(ctx, laceColor, 15, -42)
  LaceOfAroundWetTop1(ctx, laceColor, 9, -30)
  LaceOfAroundWetTop1(ctx, laceColor, 6, -20)
  LaceOfAroundWetTop1(ctx, laceColor, 3, -10)
  LaceOfAroundWetTop1(ctx, laceColor, 0, 0)

  // ウェブ先端_右
  LaceOfAroundWetTop1(ctx, laceColor, 124, -161)
  LaceOfAroundWetTop1(ctx, laceColor, 116, -155)
  LaceOfAroundWetTop1(ctx, laceColor, 108, -148)
  LaceOfAroundWetTop1(ctx, laceColor, 98, -138)
  LaceOfAroundWetTop1(ctx, laceColor, 90, -129)
  LaceOfAroundWetTop1(ctx, laceColor, 84, -120)
  LaceOfAroundWetTop1(ctx, laceColor, 77, -112)
  LaceOfAroundWetTop1(ctx, laceColor, 72, -102)
}

const LaceOfAroundWetTop1 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(206 + x, 240 + y) // 左上
  ctx.quadraticCurveTo(208 + x, 238 + y, 216 + x, 250 + y) // 左下
  ctx.quadraticCurveTo(219 + x, 245 + y, 219 + x, 239 + y) // 右下
  ctx.quadraticCurveTo(213 + x, 231 + y, 209 + x, 231 + y) // 右上
  ctx.quadraticCurveTo(204 + x, 233 + y, 206 + x, 240 + y) // 左上
  ctx.fill()
  ctx.moveTo(206 + x, 238 + y) // 左上
  ctx.quadraticCurveTo(211 + x, 238 + y, 218 + x, 248 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}

const baseLaceOfWetTopLeft = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(206, 253) // 親指＿左
  ctx.quadraticCurveTo(211, 257, 214, 255) // 親指＿右
  ctx.quadraticCurveTo(222, 187, 258, 172) // ウェブ中央＿右上
  ctx.quadraticCurveTo(257, 161, 254, 164) // ウェブ中央＿左上
  ctx.quadraticCurveTo(214, 187, 206, 253) // 親指＿左
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const baseLaceOfWetTopRight = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(273, 148) // ウェブ中央＿上
  ctx.quadraticCurveTo(277, 155, 277, 155) // ウェブ中央＿下
  ctx.quadraticCurveTo(310, 97, 351, 72) // 人差指＿下
  ctx.quadraticCurveTo(351, 67, 351, 59) // 人差指＿上
  ctx.quadraticCurveTo(305, 92, 273, 148) // ウェブ中央＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const laceOfWebTopCenter = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  // 左
  ctx.beginPath()
  ctx.moveTo(252, 163) // 左下
  ctx.quadraticCurveTo(254, 163, 260, 170) //右下
  ctx.quadraticCurveTo(263, 168, 262, 165) //右上
  ctx.quadraticCurveTo(260, 159, 255, 158) //左上
  ctx.quadraticCurveTo(251, 158, 252, 163) //左下
  ctx.fill()
  ctx.moveTo(252, 161) // 左下
  ctx.quadraticCurveTo(257, 163, 261, 169) //右下
  ctx.stroke()
  ctx.closePath()
  // 右
  ctx.beginPath()
  ctx.moveTo(271, 142) // 左上
  ctx.quadraticCurveTo(269, 146, 273, 153) // 左下
  ctx.quadraticCurveTo(274, 157, 280, 154) // 右下
  ctx.quadraticCurveTo(277, 146, 277, 143) // 右上
  ctx.quadraticCurveTo(275, 138, 271, 142) // 左上
  ctx.fill()
  ctx.moveTo(275, 141) // 右上
  ctx.quadraticCurveTo(274, 146, 279, 154) // 右下
  ctx.stroke()
  ctx.closePath()
}

export const laceOfNetWeb2 = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  // ネットウェブ用の革紐最右
  laceParts6(ctx, laceColor, -3, -50) // 上1
  laceParts6(ctx, laceColor, -2, -25) // 上1
  laceParts6(ctx, laceColor, 0, 0) // 上2
  laceParts6(ctx, laceColor, 5, 27) // 上3
  laceParts6(ctx, laceColor, 8, 55) // 上4
  laceParts6(ctx, laceColor, 14, 84) // 上5
}
